export default __webpack_public_path__ + "static/media/icon-eproform.f5f4666e.svg";